import { create } from "zustand";

type AgentState = {
	clear: () => void;
};

export const useAgentStore = create<AgentState>((set) => ({
	clear: () => set({}),
}));
